import { Box } from "@mui/material"
import React, { useContext } from "react"
import CommonTypo from "../../components/CommonTypo"
import { UserTypeContext } from "../../context/userStatus";
import moment from "moment";
import { userService } from "../../services/auth";

const Membership = ({
    setShowSnakbar,
    setSnakbarMsg,
    setMsgType
}) => {
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const { userDetails, planProducts } = IUserTypeState
    const selectedPlanName = planProducts.length ? planProducts.find(it => it.name === userDetails.planName) : {}
    let price = "9.99"
    if (selectedPlanName) {
        price = (selectedPlanName.price.unit_amount / 100).toFixed(2)
    }
    let expiryDate = null
    if (userDetails?.paymentExpiry_date) {
        expiryDate = moment(userDetails?.paymentExpiry_date).format("DD/MM/YYYY")
    }
    const token = localStorage.getItem("userDetails")
    const getBillingPorta = () => {
        userService.billingPortal(token).then(data => {
            window.open(data.data.url)
        }).catch(err => {
            console.log("err", err);

        })
    }
    return <Box display={"flex"} flexDirection={"column"} width={"100%"} alignSelf={"stretch"} gap={"24px"}>
        <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} width={"100%"} alignSelf={"stretch"} paddingBottom={"16px"} gap={"24px"}
            borderBottom="1px dashed #EEEEEE"
        >
            <CommonTypo size={16} lineHeight={19.2} color="var(--color-text-primary)">{selectedPlanName?.name || "Free Plan"}</CommonTypo>
            <CommonTypo size={16} lineHeight={19.2} color="var(--color-text-primary)">Your next bill is for ${price} on {expiryDate}</CommonTypo>
        </Box>
        {/* <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} width={"100%"} alignSelf={"stretch"} paddingBottom={"16px"} gap={"24px"}
            borderBottom="1px dashed #EEEEEE"
        >
            <CommonTypo size={16} lineHeight={19.2} color="var(--color-text-primary)">Mastercard *1234</CommonTypo>
            <CommonTypo size={16} lineHeight={19.2} color="var(--color-text-primary)">Expires 05/2030</CommonTypo>
        </Box> */}
        <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} width={"100%"} alignSelf={"stretch"} paddingBottom={"16px"} gap={"24px"}
            borderBottom="1px dashed #EEEEEE"
            sx={{
                cursor: "pointer"
            }}
            onClick={getBillingPorta}
        >
            <CommonTypo size={16} lineHeight={19.2} color="#367DEF">Manage subscription</CommonTypo>
            <CommonTypo size={16} lineHeight={19.2} color="#367DEF">{">"}</CommonTypo>
        </Box>
        {/* <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} width={"100%"} alignSelf={"stretch"} paddingBottom={"16px"} gap={"24px"}
            sx={{
                cursor: "pointer"
            }}
            onClick={getBillingPorta}
        >
            <CommonTypo size={16} lineHeight={19.2} color="var(--color-text-primary)">Cancel subscription</CommonTypo>
            <CommonTypo size={16} lineHeight={19.2} color="var(--color-text-primary)">{">"}</CommonTypo>
        </Box> */}
    </Box>
}

export default Membership